<template>
  <div class="footer">
    <router-link :to="{ name: 'dashboard' }">
      <el-button type="text" :to="{ name: 'dashboard' }">
        <img src="@/assets/img/logos/logo-v-gray.png" class="logo">
      </el-button>
    </router-link>
    <br>
    &copy; Saffron App 2019. All Rights Reserved.
  </div>
</template>

<script>
  export default {
    name: 'Footer',
  };
</script>

<style lang="scss" scoped>
  .footer{
    padding: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue